import {useQuery} from 'react-query';

import {evalApi} from 'src/lib/api/eval';

export function useSiteSummary(siteId: string) {
  const {
    data: summary,
    isLoading,
    error,
  } = useQuery(
    ['eval', 'site', siteId, 'summary'],
    () => evalApi.getSiteSummary(siteId),
    {enabled: !!siteId, staleTime: 5 * 60 * 1000} // Cache for 5 minutes
  );

  return {summary, isLoaded: !isLoading, error};
}
